export default class {
  constructor($uibModalInstance, data) {
    'ngInject';
    this.$uibModalInstance = $uibModalInstance;
    this.option = data.option;
  }
  ok() {
    this.$uibModalInstance.close();
  }
  cancel() {
    this.$uibModalInstance.dismiss();
  }
}
